import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col sm:gap-4 sm:py-4" }
const _hoisted_2 = { class: "grid flex-1 items-start gap-4 sm:py-0 md:gap-8 max-w-[85rem] mx-auto w-full px-4 sm:px-6" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "ml-auto flex items-center gap-2" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex gap-3 justify-center" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex gap-3 justify-center" }
const _hoisted_11 = {
  key: 0,
  class: "text-xs text-muted-foreground"
}
const _hoisted_12 = { class: "flex gap-2 items-center" }

import {
  PlusCircle,
  AlertTriangle,
  Loader2,
  Pencil,
  Trash2,
  GraduationCap
} from 'lucide-vue-next'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import {
  Tabs,
  TabsContent,
} from '@/components/ui/tabs'

import { onMounted, ref } from 'vue'
import { useAxios } from '@/composables/useAxios'
import SpinnerLoader from '@/components/ui/loaders/SpinnerLoader.vue'
import { Course } from '@/interfaces/Course'
import { Pagination as IPagination } from '@/interfaces/Pagination'
import PaginationApi from '@/components/ui/pagination/PaginationApi.vue'
import { Dialog } from '@/components/ui/dialog'
import DialogContent from '@/components/ui/dialog/DialogContent.vue'
import DialogHeader from '@/components/ui/dialog/DialogHeader.vue'
import DialogTitle from '@/components/ui/dialog/DialogTitle.vue'
import DialogDescription from '@/components/ui/dialog/DialogDescription.vue'
import DialogFooter from '@/components/ui/dialog/DialogFooter.vue'
import DialogClose from '@/components/ui/dialog/DialogClose.vue'
import { toast, Toaster } from '@/components/ui/toast'
import { CourseMediaTypeEnum } from '@/enums/course/CourseMediaTypeEnum'
import { courseStatusLabels } from '@/enums/course/CourseStatusEnum'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { Breadcrumb, BreadcrumbEllipsis, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb"


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexCoursesView',
  setup(__props) {

const axios = useAxios()
const courses = ref<IPagination<Course>>()
const isDeleteCourseConfirmationDialogOpen = ref(false)
const selectedCourseIdToDelete = ref<number>()
const isDeletingCourse = ref(false)

function getCourses(page = 1) {
  axios.get('/courses', { params: { page, owner: true } })
    .then((res) => {
      courses.value = res.data
    })
}

function deleteCourse(id: number) {
  isDeletingCourse.value = true

  axios.delete(`/courses/${id}`)
    .then(() => {
      toast({
        title: 'Curso excluído com sucesso',
        class: 'bg-green-500 text-white'
      })

      courses.value!.data = courses.value!.data.filter((course) => course.id !== id)
    })
    .catch(() => isDeletingCourse.value = false)
    .finally(() => {
      isDeletingCourse.value = false
      isDeleteCourseConfirmationDialogOpen.value = false
    })
}

onMounted(() => {
  getCourses()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_unref(Tabs), { "default-value": "all" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Breadcrumb), null, {
              default: _withCtx(() => [
                _createVNode(_unref(BreadcrumbList), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BreadcrumbItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(BreadcrumbLink), null, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode("Cursos")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(BreadcrumbSeparator))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Button), {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'courses.create' }))),
                size: "sm",
                class: "h-9 gap-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(PlusCircle), { class: "h-3.5 w-3.5" }),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "sr-only sm:not-sr-only sm:whitespace-nowrap" }, " Adicionar Curso ", -1))
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_unref(TabsContent), { value: "all" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Card), { class: "bg-[unset]" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CardHeader), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CardTitle), { class: "text-[1.1rem]" }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("Cursos")
                        ])),
                        _: 1
                      }),
                      _createVNode(_unref(CardDescription), null, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode(" Gerencie, crie e edite os seus cursos ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(CardContent), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Table), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(TableHeader), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(TableRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(TableHead), { class: "hidden w-[100px] sm:table-cell px-4" }, {
                                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                                      _createElementVNode("span", { class: "sr-only" }, "img", -1)
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_unref(TableHead), { class: "px-4" }, {
                                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                                      _createTextVNode("Título")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_unref(TableHead), { class: "px-4" }, {
                                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                                      _createTextVNode("Introdução")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_unref(TableHead), { class: "px-4 text-center" }, {
                                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                                      _createTextVNode("Status")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_unref(TableHead), { class: "px-4 text-center" }, {
                                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                                      _createTextVNode("Ações")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (courses.value)
                            ? (_openBlock(), _createBlock(_unref(TableBody), { key: 0 }, {
                                default: _withCtx(() => [
                                  (courses.value?.data && courses.value?.data.length > 0)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(courses.value.data, (course) => {
                                        return (_openBlock(), _createBlock(_unref(TableRow), {
                                          key: course.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(TableCell), { class: "hidden sm:table-cell px-4" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  alt: "Imagem do curso",
                                                  class: "aspect-square rounded-md object-cover",
                                                  height: "64",
                                                  src: course.media.find((m) => m.type === _unref(CourseMediaTypeEnum).MAIN)?.bucketLocation ?? '/assets/img/no-image.png',
                                                  onError: _cache[1] || (_cache[1] = ($event: any) => (($event.target as HTMLInputElement).src = '/assets/img/no-image.png')),
                                                  width: "64"
                                                }, null, 40, _hoisted_5)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_unref(TableCell), { class: "font-medium px-4" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(course.title), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_unref(TableCell), { class: "font-medium px-4" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(course.introduction), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_unref(TableCell), { class: "font-medium px-4 text-center" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_unref(courseStatusLabels)[course.status]), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_unref(TableCell), { class: "px-4 text-center" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_6, [
                                                  _createVNode(_unref(TooltipProvider), null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("button", {
                                                                class: "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 w-10 rounded-lg",
                                                                onClick: ($event: any) => (_ctx.$router.push({ name: 'courses.users.index', params: { courseId: course.id } }))
                                                              }, [
                                                                _createVNode(_unref(GraduationCap), { class: "w-5 h-5" })
                                                              ], 8, _hoisted_7)
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          _createVNode(_unref(TooltipContent), {
                                                            side: "top",
                                                            "side-offset": 5
                                                          }, {
                                                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                              _createTextVNode(" Alunos ")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_unref(TooltipProvider), null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("button", {
                                                                class: "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 w-10 rounded-lg",
                                                                onClick: ($event: any) => (_ctx.$router.push({ name: 'courses.edit', params: { courseId: course.id } }))
                                                              }, [
                                                                _createVNode(_unref(Pencil), { class: "w-5 h-5" })
                                                              ], 8, _hoisted_8)
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          _createVNode(_unref(TooltipContent), {
                                                            side: "top",
                                                            "side-offset": 5
                                                          }, {
                                                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                              _createTextVNode(" Editar ")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_unref(TooltipProvider), null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("button", {
                                                                class: "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 w-10 rounded-lg",
                                                                onClick: ($event: any) => {isDeleteCourseConfirmationDialogOpen.value = true; selectedCourseIdToDelete.value = course.id}
                                                              }, [
                                                                _createVNode(_unref(Trash2), { class: "w-5 h-5" })
                                                              ], 8, _hoisted_9)
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          _createVNode(_unref(TooltipContent), {
                                                            side: "top",
                                                            "side-offset": 5
                                                          }, {
                                                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                              _createTextVNode(" Excluir ")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    : (_openBlock(), _createBlock(_unref(TableRow), { key: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(TableCell), {
                                            colspan: "5",
                                            class: "text-center font-medium py-8"
                                          }, {
                                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                                              _createTextVNode(" Nenhum curso encontrado. ")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_unref(TableBody), { key: 1 }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                                    return _createVNode(_unref(TableRow), {
                                      key: i,
                                      class: "animate-pulse"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(TableCell), { class: "hidden sm:table-cell px-4" }, {
                                          default: _withCtx(() => _cache[17] || (_cache[17] = [
                                            _createElementVNode("div", { class: "h-16 w-16 bg-zinc-800 rounded-md" }, null, -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_unref(TableCell), { class: "px-4" }, {
                                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                                            _createElementVNode("div", { class: "h-4 bg-zinc-800 rounded w-24" }, null, -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_unref(TableCell), { class: "px-4" }, {
                                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                                            _createElementVNode("div", { class: "h-4 bg-zinc-800 rounded w-48" }, null, -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_unref(TableCell), { class: "px-4" }, {
                                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                                            _createElementVNode("div", { class: "h-4 bg-zinc-800 rounded w-20 mx-auto" }, null, -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_unref(TableCell), { class: "px-4 text-center" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_10, [
                                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (j) => {
                                                return _createElementVNode("div", {
                                                  key: j,
                                                  class: "h-10 w-10 bg-zinc-800 rounded-lg"
                                                })
                                              }), 64))
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1024)
                                  }), 64))
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }),
                      (courses.value)
                        ? (_openBlock(), _createBlock(PaginationApi, {
                            key: 0,
                            data: courses.value.pagination,
                            paginate: (page) => { courses.value = undefined; getCourses(page) }
                          }, null, 8, ["data", "paginate"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(CardFooter), null, {
                    default: _withCtx(() => [
                      (courses.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _cache[21] || (_cache[21] = _createTextVNode(" Exibindo ")),
                            _createElementVNode("strong", null, "1-" + _toDisplayString(courses.value.data.length), 1),
                            _cache[22] || (_cache[22] = _createTextVNode(" de ")),
                            _createElementVNode("strong", null, _toDisplayString(courses.value.pagination.total), 1),
                            _cache[23] || (_cache[23] = _createTextVNode(" resultados "))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (selectedCourseIdToDelete.value)
                ? (_openBlock(), _createBlock(_unref(Dialog), {
                    key: 0,
                    open: isDeleteCourseConfirmationDialogOpen.value,
                    "onUpdate:open": _cache[3] || (_cache[3] = (open) => isDeleteCourseConfirmationDialogOpen.value = open)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(DialogContent, { class: "sm:max-w-md" }, {
                        default: _withCtx(() => [
                          _createVNode(DialogHeader, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_unref(AlertTriangle), { class: "h-6 w-6" }),
                                _createVNode(DialogTitle, { class: "text-[1.1rem]" }, {
                                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                                    _createTextVNode("Cuidado")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _createVNode(DialogDescription, { class: "py-2" }, {
                                default: _withCtx(() => _cache[25] || (_cache[25] = [
                                  _createTextVNode(" Deseja mesmo deletar esse curso? ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "flex items-center space-x-2" }, null, -1)),
                          _createVNode(DialogFooter, { class: "sm:justify-start" }, {
                            default: _withCtx(() => [
                              _createVNode(DialogClose, { "as-child": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Button), {
                                    type: "button",
                                    variant: "secondary"
                                  }, {
                                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                                      _createTextVNode(" Cancelar ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(Button), {
                                type: "button",
                                disabled: isDeletingCourse.value,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (deleteCourse(selectedCourseIdToDelete.value)))
                              }, {
                                default: _withCtx(() => [
                                  (isDeletingCourse.value)
                                    ? (_openBlock(), _createBlock(_unref(Loader2), {
                                        key: 0,
                                        class: "w-4 h-4 mr-2 animate-spin"
                                      }))
                                    : _createCommentVNode("", true),
                                  _cache[27] || (_cache[27] = _createTextVNode(" Confirmar "))
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(Toaster))
    ])
  ]))
}
}

})